import { compile } from '@/core/index'
import Basic from './Basic'

export default class Form extends Basic {
  constructor(el, opt) {
    super(el, opt)
    this.init()
  }

  init() {
    const { block } = this.settings
    if (block === 'widget') {
      this.hasIds()
    } else {
      this.hasTemplate()
    }
  }

  hasIds() {
    const { ids = [] } = this.settings
    ids.forEach((id) => {
      const el = $(`#${id}`)
      if (!el || !el.length) return console.error(`选择器${this.el}不存在!初始化前,确认此选择器是否已挂载.`)
      const obj = compile.input(el[0], { ...this.settings })
      el.after(obj.outer)
      el.detach()
      this.obj = obj
    })
  }

  hasTemplate() {
    const el = this.$el
    if (!el) return console.error(`${el}不存在!初始化前,确认此选择器是否已挂载.`)
    const temp = (this.temp = compile.read(el))
    if (!temp) return console.error(`${el}不存在的模板!`)
    if (this.settings.empty) this.destroy()
    const { inner, outer } = this.toForm(el, this.settings)
    Object.assign(this, { inner, outer })
    this.update()
    el.append(outer)
  }

  toForm(el, opt) {
    let outer = el
    let inner = ''
    const { block } = opt
    if (block === 'row') {
      if (outer) outer.removeClass('lt-form__*').addClass('lt-form__row')
      else outer = $('<div class="lt-form__row\'"></div>')
      inner = $('<form class="lt-form"></form>')
    } else if (block === 'square') {
      if (outer) outer.removeClass('lt-form__*').addClass('lt-form__square')
      else outer = $('<div class="lt-form__square\'"></div>')
      inner = $('<form class="lt-form"></form>')
    } else {
      if (outer) outer.removeClass('lt-form__*')
      else outer = $('<div></div>')
      inner = $('<form class="lt-form"></form>')
    }
    outer.append(inner)
    return { outer, inner }
  }

  update() {
    const { temp, inner } = this
    const { block, size } = this.settings
    const objs = {}
    Array.from(temp).map((input) => {
      if (input.tagName === 'INPUT') {
        const obj = compile.input(input, { block, size })
        inner.append(obj.outer)
        const name = obj.name
        objs[name] = obj
      } else if (input.tagName === 'SECTION') {
        const obj = compile.section(input)
        inner.append(obj)
      }
    })
    this.settings.objs = objs
  }
}
